import BaseApiService from '../baseApi.service';

export default class CacheService extends BaseApiService {
  readonly basePath: string = 'cache/v1';
  constructor(props = null) {
    super(props);
  }
}
